import { InformationPopover } from "@/molecules/InformationPopover"

import styles from "./HeaderCell.module.scss"

import type { HeaderCellProps } from "."

export const HeaderCell = (props: HeaderCellProps) =>
  function HeaderCellComponent() {
    const {
      title,
      Content,
      titlePopover,
      whiteSpace,
      placement = "top"
    } = props

    return (
      <div className={styles.container}>
        {title}
        <InformationPopover.Popover
          placement={placement}
          classNamePopover={styles.popover}
          content={
            <InformationPopover.CommonTemplate
              title={titlePopover}
              whiteSpace={whiteSpace}
            >
              {typeof Content === "string" ? Content : <Content />}
            </InformationPopover.CommonTemplate>
          }
        />
      </div>
    )
  }
